import React from 'react';
import { Box } from '@mui/material';
import { Link } from 'gatsby';

interface LinkerProps {
  children: React.ReactNode;
  value?: {
    link: {
      newTab: boolean;
      path: string;      
      url: string;
      color: {
        hex: string;
      }
      hoverColor: {
        hex: string;
      }
      underline: boolean;
    };
  };
}

const Linker = ({ children, value }: LinkerProps) => {
    
  if (!value) return children;

  if (value.link?.path) {
    return (
      <>
        <Box
        component={Link}
        to={value.link.path ?? '/'} 
        target={value.link.newTab ? '_blank' : '_self'}
        sx={{
          color: value.link?.color?.hex ?? undefined,
          textDecoration: value.link?.underline ? 'underline' : 'none',
          '&:hover': {
            color: value?.link?.hoverColor?.hex ?? undefined
          }
        }}
        >
          {children}
        </Box>
      </>
    );
  }

  if (value.link?.url) {
    return (
      <>
        <Box
        component={'a'}
        href={value.link.url} 
        target={value.link.newTab ? '_blank' : '_self'}
        sx={{
          color: value.link?.color?.hex ?? undefined,
          textDecoration: value.link?.underline ? 'underline' : 'none',
          '&:hover': {
            color: value?.link?.hoverColor?.hex ?? undefined
          }
        }}
        >
          {children}
        </Box>
      </>
    );
  }
};

export default Linker;
